import React, { useState, useEffect } from 'react';
import PageDescription from "../admin/DataAnalyst/sections/PageDescription";
import AppTour from '../../components/AppTour/AppTour';
import { musicReleaseTourSteps } from '../../components/AppTour/ModuleTourSteps';

const MUSIC_RELEASE_URL = 'https://upncomer-media.s3.us-west-2.amazonaws.com/distribution/release/'

export default function MusicRelease() {
    const [runTour, setRunTour] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const startIfHash = () => {
            const hash = window.location.hash || '';
            if (hash === '#start-tour') {
                setRunTour(true);
            }
        };

        startIfHash();
        const onHashChange = () => startIfHash();
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, [setRunTour]);

    const imageCount = 35;
    const images = Array.from({ length: imageCount }).map((_, i) => {
        const idx = i + 1;
        return `${MUSIC_RELEASE_URL}release-${idx}.png`;
    });

    return (
        <div className="DataAnalyst-page py-5">
            <div className="container max-w-full">
                <PageDescription
                    title="Release & Publishing Music Demo"
                    description="UpNComer Release & Publishing Music Demo"
                />

                <div className="performance-section relative bg-theme_clr1 rounded-xl mb-5 p-4 lg:px-5 pt-[26px] pb-[30px]" data-tour="performance-section">
                    <div className="flex flex-col gap-4">
                        {images.map((img, idx) => (
                            <div key={idx} data-tour={`release-${idx + 1}`} className="w-full rounded-lg overflow-hidden">
                                <img src={img} alt={`Release ${idx + 1}`} className="w-full h-auto block" loading="lazy" />
                            </div>
                        ))}
                    </div>
                </div>

                <AppTour tourSteps={musicReleaseTourSteps} runTour={runTour} setRunTour={setRunTour} />
            </div>
        </div>
    )
}